const axios = require('axios').default

const tenantEndPoint = `${process.env.API_BASE_URL}users/info`

export default {
  getTenantName() {
    const defaultTenant = 'default'
    return axios
      .get(tenantEndPoint)
      .catch(error => {
        console.log(error)
        return defaultTenant
      })
      .then(response => {
        let tenant = defaultTenant
        if (response.headers['domain-tenant']) {
          tenant = response.headers['domain-tenant']
        }

        return tenant
      })
  }
}
